import _defineProperty from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
globalThis.jotaiAtomCache = globalThis.jotaiAtomCache || {
  cache: new Map(),
  get: function get(name, inst) {
    if (this.cache.has(name)) {
      return this.cache.get(name);
    }

    this.cache.set(name, inst);
    return inst;
  }
};

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import _styled from "styled-components";
import { Button, Title } from '../../..';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var CommonModalWrapper = function CommonModalWrapper(_ref) {
  var mainTitle = _ref.mainTitle,
      subTitle = _ref.subTitle,
      isReversedHeadAndContent = _ref.isReversedHeadAndContent,
      children = _ref.children,
      primaryButtonProps = _ref.primaryButtonProps,
      secondaryButtonProps = _ref.secondaryButtonProps,
      loading = _ref.loading,
      icon = _ref.icon,
      textAlignment = _ref.textAlignment;
  return /*#__PURE__*/_jsxs(_StyledDiv, {
    children: [mainTitle && /*#__PURE__*/_jsxs(SecondWrapperDiv, {
      isReversed: isReversedHeadAndContent,
      children: [icon ? /*#__PURE__*/_jsx(_StyledDiv2, {
        children: icon
      }) : null, /*#__PURE__*/_jsxs(ThirdWrapperDiv, {
        textAlignment: textAlignment,
        children: [/*#__PURE__*/_jsx(Title, {
          content: mainTitle,
          variant: "h3-large",
          fontWeight: "semibold",
          twStyle: {
            "lineHeight": "1.688rem"
          }
        }), subTitle ? /*#__PURE__*/_jsx(Title, {
          content: subTitle,
          fontSize: "base",
          fontWeight: "normal",
          textColor: "gray",
          twStyle: {
            "lineHeight": "1.5rem"
          }
        }) : null]
      }), children]
    }), /*#__PURE__*/_jsxs(_StyledDiv3, {
      children: [primaryButtonProps ? /*#__PURE__*/_jsx(Button, _objectSpread({
        loading: loading,
        variant: "normal",
        fullwidth: true
      }, primaryButtonProps)) : null, secondaryButtonProps ? /*#__PURE__*/_jsx(Button, _objectSpread({
        variant: "secondary-outline",
        fullwidth: true
      }, secondaryButtonProps)) : null]
    })]
  });
};

var SecondWrapperDiv = /*#__PURE__*/_styled.div.withConfig({
  displayName: "common-modal-wrapper__SecondWrapperDiv",
  componentId: "sc-8yc2lc-0"
})(["", " ", ""], {
  "display": "flex",
  "width": "100%",
  "flexDirection": "column",
  "alignItems": "center",
  "gap": "1.25rem"
}, function (_ref2) {
  var isReversed = _ref2.isReversed;
  return isReversed ? {
    "flexDirection": "column-reverse"
  } : {
    "flexDirection": "column"
  };
});

var ThirdWrapperDiv = /*#__PURE__*/_styled.div.withConfig({
  displayName: "common-modal-wrapper__ThirdWrapperDiv",
  componentId: "sc-8yc2lc-1"
})(["", " ", ""], {
  "display": "flex",
  "width": "100%",
  "maxWidth": "24rem",
  "flexDirection": "column",
  "alignItems": "center",
  "gap": "0.5rem",
  "textAlign": "center"
}, function (_ref3) {
  var textAlignment = _ref3.textAlignment;
  return textAlignment === 'left' ? {
    "textAlign": "left"
  } : {
    "textAlign": "center"
  };
});

var _StyledDiv = /*#__PURE__*/_styled("div").withConfig({
  displayName: "common-modal-wrapper___StyledDiv",
  componentId: "sc-8yc2lc-2"
})({
  "display": "flex",
  "width": "100%",
  "flexDirection": "column",
  "gap": "2rem"
});

var _StyledDiv2 = /*#__PURE__*/_styled("div").withConfig({
  displayName: "common-modal-wrapper___StyledDiv2",
  componentId: "sc-8yc2lc-3"
})({
  "marginLeft": "auto",
  "marginRight": "auto"
});

var _StyledDiv3 = /*#__PURE__*/_styled("div").withConfig({
  displayName: "common-modal-wrapper___StyledDiv3",
  componentId: "sc-8yc2lc-4"
})({
  "display": "flex",
  "width": "100%",
  "flexDirection": "column",
  "gap": "0.5rem"
});